module.exports = __webpack_public_path__ + "img/phone-service-sp.0bbe7b4.png";